export const dataWarehouse = {
  input: {
    dataSet: "Data-Set",
    getData: "Data-Set auslesen",
    getDataSuccess: "Data-Set erfolgreich ausgelesen"
  }
};
